import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import queryString from 'query-string'

import { AdvancedTable } from '@/components/tables/AdvancedTable/AdvancedTable'

import { getScoreThreshold } from '../../helpers'

import './dashboardTable.css'

export const DashboardTableColoredCell = ({ score, scorecardConfig }) => {
  const scoreColor = getScoreThreshold(score, scorecardConfig)

  return (
    <div
      className={`scorecard-dashboard__colored-cell ${scoreColor}`}
      data-testid="dashboard-table__colored-cell"
    >
      {`${score.toFixed(2)}%`}
    </div>
  )
}

export const DashboardTable = () => {
  const { data, loading } = useSelector((state) => state.scorecards)

  // The agent rides in the URL (not an onClick dispatch) so plain, cmd, and
  // middle clicks all land on a correctly filtered scores page.
  const agentScoresPath = (row) =>
    `/scorecards/view_scores?${queryString.stringify({
      agent_id: row.user_id.value,
      agent_name: row.user_full_name,
    })}`

  // Filter out scorecard scores here.
  const columns = data.tableHeaders?.scorecardDashboard
    .filter(
      (header) =>
        !header.accessor.startsWith('total_calls_') && !header.accessor.startsWith('score_')
    )
    .map((header) =>
      header.accessor === 'user_full_name'
        ? {
            ...header,
            format: (value, row) => (
              <Link to={agentScoresPath(row)} className="table-link">
                {value}
              </Link>
            ),
          }
        : header
    )
  const rows = data.tableRows?.scorecardDashboard.map((userAggregate) => {
    const formattedRow = {}
    Object.keys(userAggregate).forEach((value) => {
      if (value === 'user_full_name' || value === 'overall_total_calls') {
        formattedRow[value] = userAggregate[value]
      } else {
        const aggregateCellData = userAggregate[value]
        formattedRow[value] = {
          as: (
            <DashboardTableColoredCell
              score={aggregateCellData}
              scorecardConfig={data.targetScorecardConfig}
            />
          ),
          value: aggregateCellData,
          cellProps: {
            className: getScoreThreshold(aggregateCellData, data.targetScorecardConfig),
          },
        }
      }
    })
    return formattedRow
  })

  return (
    <div className="scorecard-dashboard__table" data-testid="scorecard-dashboard__table">
      <AdvancedTable
        rows={rows}
        columns={columns}
        loading={loading.aggregateScoresByUser}
        defaultOrderBy="percentage_score"
        defaultOrder="desc"
        pagination
      />
    </div>
  )
}
